import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
	selector: 'bb-toast',
	templateUrl: './bb-toast.component.html',
	styleUrls: ['./bb-toast.component.scss']
})

export class BbToastComponent implements OnInit {
	@Input() message: string;
	@Input() icon: string;

	@Output() toastCompleted = new EventEmitter();

	visible = true;

	constructor() {

		setTimeout(() => {
			this.visible = false;

			setTimeout(() => {
				// wait for animation finish
				this.toastCompleted.emit();
			}, 1000);

		}, 3500);
	}

	ngOnInit() {
		this.icon = this.icon || 'exclamation-triangle';
	}
}
